// extracted by mini-css-extract-plugin
export default {"container":"TimeoutPopUp_container__ST+Ow","card":"TimeoutPopUp_card__xGgVx","icon":"TimeoutPopUp_icon__E0u8M","message":"TimeoutPopUp_message__ocKy5"};